module.exports = __webpack_public_path__ + "static/media/微波测量仿真分系统专用软件.748a1494.png";